module.exports = __webpack_public_path__ + "static/media/canari_fireworks.9dfa863a.png";